/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

const getters = {

	// COMPONENT
		// vx-autosuggest
	// starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: state => {

    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return "xl"
    else if (state.windowWidth >= 992) return "lg"
    else if (state.windowWidth >= 768) return "md"
    else if (state.windowWidth >= 576) return "sm"
    else return "xs"
  },

  scrollbarTag: state => {
    return state.is_touch_device ? 'div' : 'VuePerfectScrollbar'
  },

  isInCart: state => itemId => {
    return state.cartItems.some((item) => item.id == itemId );
  },

  getParameter: state => paramSearch => {
    const result = state.parameters.filter((parameter) => parameter.id === paramSearch);
    return result.length ? result.pop() : []
  },

  getStock: state => params => {
    const stock = state.realtime.filter((item) => item.id === 'stock');
    if (stock.length > 0) {
      const warehouse = stock[0].warehouses.filter((item) => item.id === params.warehouseId);
      if (warehouse.length > 0) {
        const product = warehouse[0].products.filter((item) => item.id == params.productId);
        if (product.length > 0) {
          return product.pop();
        }
      }
    }
    // const result = state.realtime.stock.warehouses.filter((warehouse) => warehouse.id === params.warehouseId).filter((product) => product.id === params.productId);
    return {id: params.productId, onHand: 0}
  }
}

export default getters
